/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Usd_MonthInputs */

const en_pricing_usd_month = /** @type {(inputs: Pricing_Usd_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USD / month`)
};

const es_pricing_usd_month = /** @type {(inputs: Pricing_Usd_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USD / mes`)
};

/**
* | output |
* | --- |
* | "USD / month" |
*
* @param {Pricing_Usd_MonthInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_usd_month = /** @type {((inputs?: Pricing_Usd_MonthInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Usd_MonthInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_usd_month(inputs)
	return en_pricing_usd_month(inputs)
});